<template>
  <div id="app">
   <keep-alive>
      <!-- 一级路由出口 -->
      <router-view/>
   </keep-alive>
  </div>
</template>

<script>
// import i18n from '@/i18n/index.js'
function getLocInfo () {
  navigator.geolocation.getCurrentPosition(
    (position) => {
      const newTimeLoc = {
        time: Date.now(),
        lat: position.coords.latitude,
        lng: position.coords.longitude
      }
      window.localStorage.setItem('currentTimeLoc', JSON.stringify(newTimeLoc))
    },
    () => {}
  )
}
getLocInfo()
setInterval(() => {
  getLocInfo()
}, 300000)
export default {
  name: 'App',
  created () {
    // i18n.locale = process.env.VUE_APP_LANG
  }
}
</script>
<style lang="less" scoped>
// html { overflow-x: hidden; overflow-y: auto; }
// ::-webkit-scrollbar {
//   display: none;
// }
#app {
  font-size: 12px;
}
</style>
